"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATC = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const atc_style_1 = __importDefault(require("./atc.style"));
class ATC extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, children } = this.props;
            return (jsx_runtime_1.jsx("div", Object.assign({ className: classes.root, "data-cy": "atomic-atc" }, { children: children }), void 0));
        };
    }
}
exports.ATC = ATC;
ATC.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node
};
ATC.defaultProps = {
    children: null
};
exports.default = react_jss_1.default(atc_style_1.default)(ATC);
//# sourceMappingURL=atc.js.map